var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0561 0L31.1642 32.3962L18.1652 36L5.20192 32.4013L2.31311 0H34.0561Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1846 33.2454L28.6884 30.3334L31.1597 2.64929H18.1846V33.2454Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1846 14.6665H8.93567L9.29184 18.6403H18.1846V14.6665Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1846 6.62323H18.1709H8.21997L8.58121 10.5972H18.1846V6.62323Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46936 20.6273L10.0261 26.8669L18.1663 29.1267L18.1846 29.1216V24.9871L18.1672 24.9917L13.7414 23.7967L13.4585 20.6273H11.308H9.46936Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0643 18.6403L22.603 23.7942L18.1709 24.9904V29.1248L26.3176 26.8669L26.3774 26.1955L27.3112 15.7336L27.4081 14.6665L28.1256 6.62323H18.1709V10.5972H23.7705L23.4089 14.6665H18.1709V18.6403H23.0643Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.2334e2540304dadfc425463699e03e52.svg";
export { ForwardRef as ReactComponent };